module.exports = __webpack_public_path__ + "static/media/it.a412b518.svg";